import { i18n, defaultNS } from "@whatslly/commons/i18nService";

i18n.addResources("en", defaultNS, {
  "selective_sync.max_suppot": "Selective sync is supported up to 3 months back",
  mark_stage_as_completed: "Mark stage as complete",
  mark_as_current_stage: "Mark as current stage",
  select_closed_stage: "Select closed stage",
  change_closed_stage: "Change closed stage",
  select_all_day_messages: "Select all messages from {{day}}",
  unknown_group: "Unknown group",
  unknown_group_actions_are_disabled: "Chat and actions are disabled for an unknown group.",
  unknown_group_participants: "Unknown group participants",
  unknown_group_participants_actions_are_disabled: "Unknown members in the group Please add all the contacts in CRM.",
  unknown_contact: "Unknown contact",
  unknown_contact_actions_are_disabled: "Chat and actions are disabled for unknown contacts.",
  unknown_contact_to_enable_actions: "To enable them add the contact to the CRM",
  multiple_records: "Multiple records",
  multiple_records_actions_are_disabled: "Chat and actions are disabled for multiple records.",
  multiple_records_to_enable_actions: "To enable them select a record or add a contact the your CRM",
  create_type: "Create {{type}}",
  loading_contact: "Loading contact, please wait",
  lead: "Lead",
  contact: "Contact",
  "person-account": "Person Account",
  "dlp.scanning_attachment": "Sending attachment...",
  "dlp.scanning_message": "Sending...",
  "dlp.attachment_blocked": "Sending attachment was blocked by policy {{policy}}",
  "dlp.audio_blocked": "Sending audio was blocked by policy {{policy}}",
  "dlp.file_corrupted_or_encrypted_file_blocked": "Sending message was blocked because file corrupted or encrypted",
  "dlp.audio_transcription_failed_blocked": "Sending audio was blocked because transcription service is unavailable. Please try again later.",
  "dlp.copy_blocked": "Copy was blocked",
  "dlp.paste_blocked": "Paste was blocked",
  limit_number_of_contacts_engaged: "You've exceeded your quota for engaged contacts, please contact your administrator",
  limit_number_of_msgs_to_unresponsive_contact:
    "You've exceeded your quota for messages sent to an unresponsive contact, please contact your administrator",
  "dlp.message_blocked": "Sending message was blocked by policy {{policy}}",
});
i18n.addResources("es", defaultNS, {
  "selective_sync.max_suppot": "Selective sync is supported up to 3 months back",
  mark_stage_as_completed: "Marcar Etapa como completado(a)",
  mark_as_current_stage: "Marcar como Etapa actual",
  select_closed_stage: "Seleccionar Etapa cerrada/o",
  change_closed_stage: "Cambiar Etapa cerrada/o",
  select_all_day_messages: "Selecciona todos los mensajes de {{day}}",
  unknown_group: "Grupo desconocido",
  unknown_group_actions_are_disabled: "El chat y las acciones están desactivados para un grupo desconocido.",
  unknown_group_participants: "Participantes desconocidos",
  unknown_group_participants_actions_are_disabled: "Grupo con miembros desconocidos. Por favor, añada todos los contactos al CRM.",
  unknown_contact: "Contacto desconocido",
  unknown_contact_actions_are_disabled: "El chat y las acciones del panel están desactivados para contactos desconocidos.",
  unknown_contact_to_enable_actions: "Para habilitarlos, añade el contacto al CRM.",
  multiple_records: "Registros múltiples",
  multiple_records_actions_are_disabled: "El chat y las acciones están desactivados para múltiples registros.",
  multiple_records_to_enable_actions: "Para habilitarlos, seleccione un registro o agregue un contacto a su CRM.",
  create_type: "Crear {{type}}",
  loading_contact: "Cargando contacto, por favor espera",
  lead: "Prospecto",
  contact: "Contacto",
  "person-account": "Cuenta personal",
  "dlp.scanning_attachment": "Enviando adjunto...",
  "dlp.scanning_message": "Envio...",
  "dlp.scanning_audio": "Analizando audio...",
  "dlp.attachment_blocked": "El envío de archivos adjuntos fue bloqueado por la regla {{policy}}",
  "dlp.audio_blocked": "El envío de audio fue bloqueado por la regla {{policy}}",
  "dlp.file_corrupted_or_encrypted_file_blocked": "El envío del mensaje fue bloqueado porque el archivo está corrupto o cifrado",
  "dlp.audio_transcription_failed_blocked": "El envío de audio fue bloqueado porque el servicio de transcripción no está disponible. Por favor, inténtelo de nuevo más tarde.",
  "dlp.copy_blocked": "El envío de mensajes fue bloqueado por la regla {{policy}}",
  "dlp.paste_blocked": "El envío de mensajes fue bloqueado por la regla {{policy}}",
  limit_number_of_contacts_engaged: "Has superado tu cuota de contactos comprometidos, por favor contacta a tu administrador",
  limit_number_of_msgs_to_unresponsive_contact:
    "Ha excedido su cuota de mensajes enviados a un contacto no receptivo. Por favor, contacte a su administrador.",
  "dlp.message_blocked": "El envío de mensajes fue bloqueado por la regla {{policy}}",
});
i18n.addResources("pt", defaultNS, {
  "selective_sync.max_suppot": "A sincronização por seleção suporta mensagens de até 3 meses atrás",
  mark_stage_as_completed: "Marcar Fase como concluído(a)",
  mark_as_current_stage: "Marcar como Fase atual",
  select_closed_stage: "Selecionar Fase fechado",
  change_closed_stage: "Alterar Fase fechado",
  select_all_day_messages: "Selecione todas as mensagens de {{day}}",
  unknown_group: "Grupo desconhecido",
  unknown_group_actions_are_disabled: "Chat e ações estão desativados para um grupo desconhecido.",
  unknown_group_participants: "Participantes desconhecidos",
  unknown_group_participants_actions_are_disabled: "Grupo com membros desconhecidos. Por favor adicione todos os contatos ao CRM",
  unknown_contact: "Contato desconhecido",
  unknown_contact_actions_are_disabled: "O chat e as ações do painel estão desativados para contatos desconhecidos.",
  unknown_contact_to_enable_actions: "Para habilitá-los, adicione o contato ao CRM.",
  multiple_records: "Múltiplos registros",
  multiple_records_actions_are_disabled: "Chat e ações estão desabilitados para múltiplos registros.",
  multiple_records_to_enable_actions: "Para habilitá-los, selecione um registro ou adicione um contato ao seu CRM.",
  create_type: "Criar {{type}}",
  loading_contact: "Carregando contato, por favor aguarde",
  lead: "Lead",
  contact: "Contato",
  "person-account": "Conta pessoal",
  "dlp.scanning_attachment": "Enviando anexo...",
  "dlp.scanning_message": "Enviando...",
  "dlp.scanning_audio": "Analisando áudio...",
  "dlp.attachment_blocked": "O envio de anexos foi bloqueado por regra {{policy}}",
  "dlp.audio_blocked": "O envio de áudio foi bloqueado por regra {{policy}}",
  "dlp.file_corrupted_or_encrypted_file_blocked": "O envio da mensagem foi bloqueado porque o arquivo está corrompido ou criptografado",
  "dlp.audio_transcription_failed_blocked": "O envio de áudio foi bloqueado porque o serviço de transcrição não está disponível. Por favor, tente novamente mais tarde.",
  "dlp.copy_blocked": "O envio de mensagens foi bloqueado por regra {{policy}}",
  "dlp.paste_blocked": "O envio de mensagens foi bloqueado por regra {{policy}}",
  limit_number_of_contacts_engaged: "Você excedeu sua cota de contatos engajados, por favor, entre em contato com seu administrador",
  limit_number_of_msgs_to_unresponsive_contact:
    "Você excedeu sua cota de mensagens enviadas a um contato sem resposta. Por favor, entre em contato com seu administrador.",
  "dlp.message_blocked": "O envio de mensagens foi bloqueado por regra {{policy}}",
});
